import { ProgressBar } from "./components/atoms";
import { Box } from "./components/cores";
import {
  useGetDescriptionConfig,
  useGetSdlConfig,
  useGetSdlJson,
  useGetTranslationConfig,
} from "./components/hooks";
import { GeneralError } from "./components/molecules";
import { FargView, PumpView, View } from "./components/pages/View";
import { ContextProvider } from "./components/providers";

function App({ listView }: { listView: string }) {
  const {
    isLoading: configIsLoading,
    isError: configIsError,
    isSuccess: configIsSuccess,
  } = useGetSdlConfig(listView);
  const {
    isLoading: jsonIsLoading,
    isError: jsonIsError,
    isSuccess: jsonIsSuccess,
  } = useGetSdlJson(listView);
  const {
    isLoading: transIsLoading,
    isError: transIsError,
    isSuccess: transIsSuccess,
  } = useGetTranslationConfig(listView);
  const {
    isLoading: descriptionIsLoading,
    isError: descriptionIsError,
    isSuccess: descriptionIsSuccess,
  } = useGetDescriptionConfig(listView);
  if (
    configIsLoading ||
    jsonIsLoading ||
    transIsLoading ||
    descriptionIsLoading
  ) {
    return (
      <Box sx={{ padding: "200px", maxWidth: 1240, margin: "auto" }}>
        <ProgressBar
          progress={
            jsonIsLoading &&
            configIsLoading &&
            transIsLoading &&
            descriptionIsLoading
              ? 0
              : 0.9
          }
        />
      </Box>
    );
  } else if (
    configIsError ||
    jsonIsError ||
    transIsError ||
    descriptionIsError ||
    !configIsSuccess ||
    !jsonIsSuccess ||
    !transIsSuccess ||
    !descriptionIsSuccess
  ) {
    return (
      <Box sx={{ maxWidth: 1240, margin: "auto" }}>
        <GeneralError
          title="Något gick fel."
          body="Var god försök senare."
          image={() => <></>}
        />
      </Box>
    );
  }
  if (listView === "test_tabeller_utomhusfarger") {
    return (
      <div className="App">
        <ContextProvider listView={listView}>
          <FargView />
        </ContextProvider>
      </div>
    );
  } else if (listView === "test_tabeller_varmepumpar") {
    return (
      <div className="App">
        <ContextProvider listView={listView}>
          <PumpView />
        </ContextProvider>
      </div>
    );
  } else {
    return (
      <div className="App">
        <ContextProvider listView={listView}>
          <View />
        </ContextProvider>
      </div>
    );
  }
}

export default App;
